import { z } from 'zod';
import { zTranslatableBgRequired } from './translatable.js';
/**
 * Admin "save testimonial" payload — same shape for both business-partner and
 * candidate testimonials. Mirrors the two Laravel testimonial controllers
 * (`names_bg`, `position_bg`, `quote_bg` required).
 */
export const testimonialSaveSchema = z.object({
    name: zTranslatableBgRequired,
    position: zTranslatableBgRequired,
    quote: zTranslatableBgRequired,
});
//# sourceMappingURL=testimonial.js.map